import { observeSelector } from './observeSelector';

export const listenDialogsControls = (
  name: string,
  beforeOpen: (dialog: HTMLDialogElement) => void = () => {},
  afterClose: (dialog: HTMLDialogElement) => void = () => {}
) => {
  const dialog = document.querySelector<HTMLDialogElement>(`[data-dialog="${name}"]`);

  if (dialog) {
    observeSelector<'click', HTMLDialogElement>('click', `[data-dialog-open="${name}"]`, () => {
      beforeOpen(dialog);

      dialog.open = true;
    });

    observeSelector<'click', HTMLDialogElement>('click', `[data-dialog-hide="${name}"]`, () => {
      dialog.open = false;

      afterClose(dialog);
    });

    observeSelector<'click', HTMLDialogElement>('click', `[data-dialog-toggle="${name}"]`, () => {
      if (!dialog.open) {
        beforeOpen(dialog);
      }

      dialog.open = !dialog.open;

      if (!dialog.open) {
        afterClose(dialog);
      }
    });
  }
};
